"use client";

import { cn } from "@gigpro/ui/tailwind/cn";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type * as React from "react";

const TooltipProvider = TooltipPrimitive.Provider;

export interface TooltipProps
  extends Omit<React.ComponentProps<typeof TooltipPrimitive.Content>, "content">,
    Pick<React.ComponentProps<typeof TooltipPrimitive.Root>, "open" | "onOpenChange" | "defaultOpen"> {
  content: React.ReactNode;
  arrowClassName?: string;
}

const Tooltip = ({
  ref,
  children,
  content,
  className,
  sideOffset = 4,
  open,
  onOpenChange,
  defaultOpen,
  arrowClassName,
  ...props
}: TooltipProps) => (
  <TooltipPrimitive.Root open={open} onOpenChange={onOpenChange} defaultOpen={defaultOpen}>
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "z-50 max-w-sm animate-in overflow-hidden rounded-md border bg-white px-3 py-1.5 text-small font-regular text-wrap text-black shadow-back fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
          className,
        )}
        {...props}
      >
        {content}
        <TooltipPrimitive.Arrow className={cn("fill-white", arrowClassName)} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
    <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
  </TooltipPrimitive.Root>
);
Tooltip.displayName = TooltipPrimitive.Root.displayName;

export { Tooltip, TooltipProvider };
